
export const DOMAIN_NAME = process.env.REACT_APP_BASE_URL;
// export const BASE_URL = `${DOMAIN_NAME}/`;
 
// console.log("BASE_URL",BASE_URL)
// export const BASE_URL = `https://echonew-dev.m-devsecops.com/`;
export const BASE_URL = `https://echo.trialdemo.uk/`;
   